/* CDX „Zuletzt angesehen" — speichert das aktuelle Produkt und lädt die zuletzt
   angesehenen per Section-Rendering-API (Such-Query id:X OR id:Y) als cdx-Cards. */
(function () {
  var el = document.querySelector('[data-cdx-recent]');
  if (!el) return;
  var KEY = 'recentlyViewedProducts';
  var pid = parseInt(el.getAttribute('data-product-id'), 10);
  var sid = el.getAttribute('data-section-id');

  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
  list = list.filter(function (x) { return x !== pid; });

  // Anzeige = bisher gesehene (ohne aktuelles), dann aktuelles vorne speichern
  var display = list.slice(0, 12);
  if (pid) { try { localStorage.setItem(KEY, JSON.stringify([pid].concat(list).slice(0, 12))); } catch (e) {} }
  if (!display.length) return;

  var q = display.map(function (id) { return 'id:' + id; }).join(' OR ');
  var searchUrl = (window.routes && window.routes.searchUrl) || '/search';
  fetch(searchUrl + '?section_id=' + encodeURIComponent(sid) + '&type=product&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var src = tmp.querySelector('[data-cdx-recent-grid]');
      var grid = el.querySelector('[data-cdx-recent-grid]');
      if (!src || !grid || !src.children.length) return;
      grid.innerHTML = src.innerHTML;
      var wrap = el.closest('.shopify-section');
      if (wrap) wrap.style.display = 'block';
      document.dispatchEvent(new Event('cdx:slider-refresh')); // Slider-Pfeile für die geladenen Cards
    })
    .catch(function () {});
})();
